export default __webpack_public_path__ + "static/media/09 Track 9.bba7f260.mp3";